const informCustomEvent = (eventName, data) => {
    if (typeof window !== "undefined") 
        window.gtag("event", eventName, { ...data })
    return null
}

export default informCustomEvent